/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const auditEventPageItemsItemActorUserIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const auditEventPageItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const auditEventPageItemsItemImpersonationIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const auditEventPageItemsItemOccurredAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const auditEventPagePageMax = 9007199254740991

export const auditEventPagePageSizeMax = 100

export const auditEventPageTotalMin = 0
export const auditEventPageTotalMax = 9007199254740991

export const AuditEventPage = zod.object({
  items: zod.array(
    zod.object({
      action: zod.enum([
        'clinic.create',
        'clinic.update',
        'clinic.deactivate',
        'clinic.reactivate',
        'connection.update',
        'connection.test',
        'user.create',
        'user.reset_password',
        'user.password_changed',
        'user.disable',
        'super_admin.bootstrap',
        'super_admin.revoke',
        'membership.create',
        'membership.role_change',
        'membership.remove',
        'settings.update',
        'settings.refresh_from_pf',
        'settings.catalog_flagged',
        'protection.update',
        'source.add',
        'source.remove',
        'impersonation.start',
        'impersonation.end',
        'errors.delete',
        'security.unblock',
        'pf_security_code.entered',
        'pf_security_code.expired',
      ]),
      actor: zod.object({
        email: zod.string().nullable(),
        name: zod.string(),
        type: zod.enum(['clinic_member', 'super_admin', 'system', 'cli']),
        userId: zod.union([zod.uuid().regex(auditEventPageItemsItemActorUserIdOneRegExp), zod.null()]),
      }),
      details: zod.union([zod.record(zod.string(), zod.unknown()), zod.null()]),
      id: zod.uuid().regex(auditEventPageItemsItemIdRegExp),
      impersonationId: zod.union([zod.uuid().regex(auditEventPageItemsItemImpersonationIdOneRegExp), zod.null()]),
      occurredAt: zod.iso.datetime({ offset: true }).regex(auditEventPageItemsItemOccurredAtRegExp),
      summary: zod.string(),
      target: zod.union([
        zod.object({
          id: zod.string().nullable(),
          label: zod.string(),
          type: zod.enum(['clinic', 'connection', 'settings', 'source', 'user', 'impersonation', 'protection']),
        }),
        zod.null(),
      ]),
    }),
  ),
  page: zod.int().min(1).max(auditEventPagePageMax),
  pageSize: zod.int().min(1).max(auditEventPagePageSizeMax),
  total: zod.int().min(auditEventPageTotalMin).max(auditEventPageTotalMax),
})

export type AuditEventPage = zod.input<typeof AuditEventPage>
export type AuditEventPageOutput = zod.output<typeof AuditEventPage>
